import React from 'react';
import classNames from 'classnames';

import * as styles from './index.module.scss';

type Props = {
  size?: 'small';
};
export const Spinner: React.FC<Props> = ({ size }) => {
  return (
    <div
      className={classNames(styles.spinner, size === 'small' && styles.small)}
    />
  );
};
